var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
import LImage from '@max/leez-image';
import ModalBaseContainer from '@max/leez-modal-base-container';
import TopView from '@max/leez-top-view';
import { convertLinkToAppMiddleOpenLink, isH5URL } from '@/utils/common';
import './index.scss';
import { getFullScreenSize } from '@/utils/layout';
import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from '@nibfe/mkt-env-api';
import { convertH5ToWebviewPath } from '@nibfe/mkt-navigate-api';
import { navigateTo } from '@max/meituan-uni-navigate';
import { TaskType } from '@/types/teamRanking';
import { useMemo, createElement } from '@max/max';
import Button from '@hfe/max-button';
import Sensor from '@max/mbc-sensor';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { BID_MAP } from '@/const';
// interface TaskTypeStrategy {
//   onCreateFeVo?: (taskItemVo: TaskItemVo, feTaskConfig: Task) => void;
//   onRefresh?: (index: number, taskItemVo: TaskItemVo) => Promise<void>;
//   onClickTaskButton: (index: number, taskItemVo: TaskItemVo) => void | Promise<void>;
//   onModalConfirm?: (taskItemVo: TaskItemVo, index?: number) => void | Promise<void>;
// }
export default function TaskPopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    const ctx = useMonitorEngineContext();
    const { tasksConfig, tasksData, preInvite, inviteBrowse } = props;
    const taskItems = useMemo(() => {
        return (tasksData === null || tasksData === void 0 ? void 0 : tasksData.map(taskItem => {
            const taskConfig = tasksConfig === null || tasksConfig === void 0 ? void 0 : tasksConfig.find(config => config.taskId === taskItem.taskId);
            if (taskConfig) {
                // 根据任务状态确定按钮状态和图片
                const isCompleted = taskItem.dayCount <= taskItem.taskDetailVO.completedCount;
                const canComplete = taskItem.dayCount > taskItem.taskDetailVO.completedCount;
                const canNotComplete = taskItem.taskDetailVO.status === 3;
                // 计算进度信息
                const progress = {
                    current: taskItem.taskDetailVO.completedCount,
                    total: taskItem.dayCount
                };
                // 确定按钮图片
                let buttonImage = '';
                if (isCompleted) {
                    buttonImage = taskConfig.COMPLETED_BUTTON_IMG;
                }
                else if (canComplete) {
                    buttonImage = taskConfig.NOT_COMPLETED_BUTTON_IMG;
                }
                else {
                    buttonImage = taskConfig.CAN_NOT_COMPLETE_BUTTON_IMG;
                }
                return {
                    // 基础信息
                    taskId: taskItem.taskId,
                    activityId: taskItem.activityId,
                    taskType: taskItem.taskType,
                    // 展示信息（优先使用前端配置）
                    taskTitle: taskConfig.taskTitle || taskItem.taskName,
                    taskDesc: taskConfig.taskDesc || taskItem.taskDesc,
                    taskBgImage: taskConfig.taskBgImage,
                    // 状态信息
                    status: taskItem.taskDetailVO.status,
                    isCompleted,
                    canComplete,
                    canNotComplete,
                    statusDesc: taskItem.taskDetailVO.desc,
                    // 进度信息
                    progress,
                    showProcess: taskConfig.showProcess,
                    // 按钮信息
                    buttonImage,
                    buttonImages: {
                        completed: taskConfig.COMPLETED_BUTTON_IMG,
                        notCompleted: taskConfig.NOT_COMPLETED_BUTTON_IMG,
                        canNotComplete: taskConfig.CAN_NOT_COMPLETE_BUTTON_IMG
                    },
                    // 奖励信息
                    reward: taskItem.reward,
                    // 分享状态
                    shareStatus: taskItem.taskDetailVO.shareStatus,
                    // 原始数据（备用）
                    originalTaskData: taskItem,
                    originalTaskConfig: taskConfig
                };
            }
            return null;
        }).filter(item => item !== null)) || [];
    }, [tasksData, tasksConfig]);
    const taskTypeStrategy = {
        [TaskType.VIEW]: {
            onClickTaskButton: (taskItem) => __awaiter(this, void 0, void 0, function* () {
                try {
                    props.lxReport(BID_MAP.TASK_BROWSE_MC);
                    yield inviteBrowse({
                        taskId: taskItem.taskId
                    });
                    props.onFetchTasksData();
                }
                catch (error) {
                    console.error('inviteBrowse error:', error);
                    // 可以添加用户友好的错误提示
                }
            })
        },
        [TaskType.ORDER]: {
            onClickTaskButton: (taskItem) => __awaiter(this, void 0, void 0, function* () {
                try {
                    props.lxReport(BID_MAP.TASK_ORDER_MC);
                    yield preInvite({
                        taskId: taskItem.taskId
                    });
                    props.onFetchTasksData();
                    jumpToOrder();
                }
                catch (error) {
                    console.error('preInvite error:', error);
                    // 可以添加用户友好的错误提示
                }
            })
        }
    };
    // 当弹窗显示时加载任务数据
    // useEffect(() => {
    //   if (props.taskPopupVisible && !props.tasksData) {
    //     props.onFetchTasksData();
    //   }
    // }, [props.taskPopupVisible]);
    // 去下单
    function jumpToOrder() {
        var _a, _b, _c, _d;
        const isInWX = isWeixinMiniProgramOrWeixinWebview();
        if (isInWX) {
            if (!props.gotoOrderUrlInWX)
                return;
            const platform = getPlatformType();
            const webviewUrl = platform === PlatformType.mtMinaWebview ?
                // 对美团小程序有特殊逻辑，使用酒小的WebView打开
                isH5URL(props.gotoOrderUrlInWX) ? `/hotel/pages/h5/index?q=${encodeURIComponent(props.gotoOrderUrlInWX)}` : props.gotoOrderUrlInWX : convertH5ToWebviewPath(props.gotoOrderUrlInWX, platform);
            return navigateTo({
                url: webviewUrl,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        else if (isMeituanAppOrWebview() || isDianpingAppOrWebview()) {
            // app、h5跳转
            if (!props.gotoOrderUrlInMt)
                return;
            navigateTo({
                url: `${props.gotoOrderUrlInMt}${((_a = props.predictCityInfoData) === null || _a === void 0 ? void 0 : _a.predictMtCityId) ? "&city_id=" + ((_b = props.predictCityInfoData) === null || _b === void 0 ? void 0 : _b.predictMtCityId) : ""}`
            });
        }
        else {
            // 兜底
            navigateTo({
                url: convertLinkToAppMiddleOpenLink(`${props.gotoOrderUrlInMt}${((_c = props.predictCityInfoData) === null || _c === void 0 ? void 0 : _c.predictMtCityId) ? "&city_id=" + ((_d = props.predictCityInfoData) === null || _d === void 0 ? void 0 : _d.predictMtCityId) : ""}`)
            });
        }
    }
    return <TopView>
      <ModalBaseContainer type="slide" visible={props.taskPopupVisible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
    }} showMask onMaskPress={props.onClose}>
        <View style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '402rpx'
    }}>
          <LImage className='task-popup-head-image' source={{
        uri: 'https://p0.meituan.net/ingee/d8b6fd02d93dcc6dc7a139ac5271d32947332.png'
    }} style={{
        width: "520rpx",
        height: "130rpx",
        marginBottom: "32rpx"
    }}>
          </LImage>
          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/6cf8828d6332134b7505a78be02119a07792.png'
    }} style={{
        width: '622rpx',
        height: '474rpx'
    }} borderRadius={0}>
            
            <ScrollView className="task-list-container">
              {taskItems === null || taskItems === void 0 ? void 0 : taskItems.map((taskItem, index) => {
        return <View key={taskItem.taskId} className="task-item">
                    <View className="task-icon">
                      <LImage source={{
            uri: 'https://p0.meituan.net/ingee/d1e25cd5506544f047370065bba923d26225.png'
        }} style={{
            width: '80rpx',
            height: '80rpx'
        }}/>
                    </View>
                    <View className="task-content">
                      <View className="task-title-row">
                        <Text className="task-title">{taskItem.taskTitle}</Text>
                        
                      </View>
                      <Text className="task-desc">{taskItem.taskDesc}</Text>
                    </View>
                    <View className="task-action">
                      <LImage source={{
            uri: taskItem.canComplete ? taskItem.buttonImages.notCompleted : taskItem.buttonImages.canNotComplete
        }} style={{
            width: '135rpx',
            height: '60rpx'
        }} onPress={() => __awaiter(this, void 0, void 0, function* () {
            // 使用策略模式处理不同类型的任务
            const strategy = taskTypeStrategy[taskItem.taskType];
            if ((strategy === null || strategy === void 0 ? void 0 : strategy.onClickTaskButton) && taskItem.canComplete) {
                yield strategy.onClickTaskButton(taskItem);
            }
            else {
                // 默认处理逻辑
                ctx._uiInteractionAPI.toast.show({
                    content: '助力次数已经达到上限啦～明天再来吧'
                });
            }
        })}/>
                    </View>
                  </View>;
    })}
              
              <View className="task-item">
                    <View className="task-icon">
                      <LImage source={{
        uri: 'https://p0.meituan.net/ingee/3903c6536db008bcfdc8150bcad0a9b84313.png'
    }} style={{
        width: '80rpx',
        height: '80rpx'
    }}/>
                    </View>
                    <View className="task-content">
                      <View className="task-title-row">
                        <Text className="task-title">{`加入好友队伍`}</Text>
                        
                      </View>
                      <Text className="task-desc">{`活动可完成一次`}</Text>
                    </View>
                    <View className="task-action">
                      <Button style={{
        width: '135rpx',
        height: '60rpx',
        // border: '1rpx solid #000000',
        borderRadius: '30rpx',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }} className={"task-join-team-btn"} onPress={() => __awaiter(this, void 0, void 0, function* () {
        if (!props.inTeam) {
            yield props.onClickJoinTeam();
            props.onClose();
        }
    })}>
                        <Text style={{
        fontSize: '24rpx',
        color: props.inTeam ? '#C2C2C2' : '#111111'
    }}>{props.inTeam ? "已加入" : "加入"}</Text>
                      </Button>
                    </View>
                  </View>
            </ScrollView>
          </LImage>
        </View>
        <Sensor onAppear={() => {
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.TASK_POPUP_MV);
    }}></Sensor>
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} onPress={props.onClose}/>
      </ModalBaseContainer>
    </TopView>;
}
